import { render, staticRenderFns } from "./pay-channel-item.vue?vue&type=template&id=640b08ac&scoped=true&"
import script from "./pay-channel-item.vue?vue&type=script&lang=js&"
export * from "./pay-channel-item.vue?vue&type=script&lang=js&"
import style0 from "./pay-channel-item.vue?vue&type=style&index=0&id=640b08ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b08ac",
  null
  
)

export default component.exports